import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store';
import OperatorState from './state';
import { MutationTypes } from './mutation-types';
import { OperatorModel, jobs, detailJobs, OperatorProperty } from '@/models/Operator';
import axios from 'axios';
import compareValues from '@/helper/sortHelper';

function createFilterConfigs(state: OperatorState, targetProperty: OperatorProperty, order?: any[]) {
    const params = state.operators.map((operator) => operator[targetProperty]);
    const filterConfigs = [];
    if ( typeof order === "undefined") {
        for (const param of Array.from(new Set(params))) {
            filterConfigs.push({ param: param, isValid: true });
        }
    } else {
        for (const param of order ) {
            filterConfigs.push({ param: param, isValid: true });
        }
    }

    state.allFilterConfigs.push({targetProperty: targetProperty, filterConfigs: filterConfigs});
}

function createOnlyCnVerConfigs(state: OperatorState) {
    createFilterConfigs(state, 'onlyCnVer');
    const onlyCnVerConfig = state.allFilterConfigs.find((config) => config.targetProperty === 'onlyCnVer');
    if (onlyCnVerConfig != null) {
        onlyCnVerConfig.filterConfigs.map((filterConfig) => {
            if (filterConfig['param'] === true) {
                filterConfig.isValid = false;
            }
        });
    }
}

type Context = ActionContext<OperatorState, RootState>;
const actions: ActionTree<OperatorState, RootState> = {
    async init(context: Context) {
        const RESOURCE_PATH = 'operators.json';

        if (context.state.operators.length === 0) {
            axios.get(RESOURCE_PATH)
                 .then((response) => {
                     const operators = response.data;
                     operators.sort(compareValues('job', jobs));
                     operators.sort(compareValues('rarity', 'desc'));
                     operators.map( (operator: OperatorModel, index: number) => { operator.sortOrder = index; } );
                     context.commit(MutationTypes.LOAD, operators);

                     createFilterConfigs(context.state, 'job', jobs);
                     createFilterConfigs(context.state, 'detailJob', detailJobs);
                     const targetProperties: OperatorProperty[] = ['rarity', 'recruitCost', 'isGroupingTarget'];
                     for (const targetProperty of targetProperties) {
                         createFilterConfigs(context.state, targetProperty);
                     }
                     createOnlyCnVerConfigs(context.state);
                 });
        }
    },

    changeIsTargetGrouping(context: Context, payload: { changed: boolean, ids: number[]}) {
        payload.ids.map((id) => context.commit(MutationTypes.CHANGE_IS_TARGET_GROUPING, { status: payload.changed, id: id }) );
    },

    changeVisible(context: Context, payload: { changed: boolean, ids: number[]}) {
        payload.ids.map((id) => context.commit(MutationTypes.CHANGE_VISIBLE, { status: payload.changed, id: id }) );
    },

    changeRecruitCost(context: Context, payload: { changed: number, ids: number[]}) {
        payload.ids.map((id) => context.commit(MutationTypes.CHANGE_RUCRUIT_COST, { status: payload.changed, id: id }) );
    },
};

export default actions;
